import { Briefcase } from "lucide-react";
import { EXPERIENCE } from "@/data/content";
import { Tag } from "@/components/primitives";

export default function ExperienceWindow() {
    return (
        <div data-testid="experience-window" className="p-6 sm:p-8">
            <div className="flex items-center justify-between border-b border-black/10 pb-4 mb-2">
                <h2 className="text-xl font-bold tracking-tight">chronology.csv — 5 rows</h2>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">2018 — 2026</span>
            </div>
            {EXPERIENCE.map((job, i) => (
                <article
                    key={job.company}
                    data-testid={`experience-item-${i}`}
                    className="group py-6 border-b border-black/10 last:border-b-0 grid sm:grid-cols-[130px_1fr] gap-2 sm:gap-6"
                >
                    <div className="font-mono text-xs text-vermilion font-bold pt-1">{job.period}</div>
                    <div>
                        <h3 className="text-lg font-bold tracking-tight group-hover:text-vermilion transition-colors duration-200">
                            {job.role}
                        </h3>
                        <p className="inline-flex items-center gap-1.5 mt-0.5 font-mono text-xs uppercase tracking-wider text-neutral-500">
                            <Briefcase size={11} /> {job.company}
                        </p>
                        <p className="mt-3 text-sm text-neutral-600 leading-relaxed">{job.description}</p>
                        <div className="mt-3 flex flex-wrap gap-1">
                            {job.tags.map((t) => (
                                <Tag key={t}>{t}</Tag>
                            ))}
                        </div>
                    </div>
                </article>
            ))}
        </div>
    );
}
